export const ONE_TIME_PRESETS = [
  { amount: 500, label: "20 meals for rescued animals" },
  { amount: 2000, label: "80 meals for rescued animals" },
  { amount: 5000, label: "200 meals for rescued animals" },
];

export function OneTimeAmountPicker({ selectedAmount, hasCustomAmount, onSelect, testIdPrefix = "guardian" }) {
  return (
    <div className="grid grid-cols-3 gap-2" data-testid={`${testIdPrefix}-onetime-amount-picker`}>
      {ONE_TIME_PRESETS.map(({ amount, label }) => {
        const active = !hasCustomAmount && selectedAmount === amount;
        return (
          <button
            key={amount}
            type="button"
            onClick={() => onSelect(amount)}
            data-testid={`${testIdPrefix}-onetime-amount-${amount}`}
            className={`h-auto min-h-[64px] rounded-xl border font-semibold transition-colors flex flex-col items-center justify-center gap-1 px-1.5 py-2.5 ${
              active
                ? "bg-amtm-give text-amtm-giveText border-amtm-give"
                : "border-amtm-border text-amtm-text hover:border-amtm-give"
            }`}
          >
            <span>₹{amount.toLocaleString("en-IN")}</span>
            <span className={`text-[10px] leading-tight font-normal text-center ${active ? "text-amtm-text/80" : "text-amtm-textMuted"}`}>
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
